import { useCallback, useEffect, useMemo } from 'react';

import { getRecordKeyFor } from '~/reducers/customerCommunicationReducer';

import fetchHeroPlannerCountryStates from '~/actions/customerCommunication/fetchHeroPlannerCountryStates';

import { useAppDispatch, useAppSelector } from '../store';

function useHeroPlannerCountryStates(countryGroupId: string, countryId: string, brand: string) {
  const [key, params] = useMemo(() => {
    const params: Parameters<typeof fetchHeroPlannerCountryStates> = [brand, countryGroupId, countryId];
    return [getRecordKeyFor(...params), params];
  }, [brand, countryGroupId, countryId]);
  const countryStatesReq = useAppSelector((state) => state.customerCommunication.countryGroupCountryStatesRecords[key]);
  const appDispatch = useAppDispatch();
  const fetchCountryStates = useCallback(() => {
    appDispatch(fetchHeroPlannerCountryStates(...params));
  }, [appDispatch, params]);
  useEffect(() => {
    fetchCountryStates();
  }, [fetchCountryStates]);

  return { countryStatesReq, fetchCountryStates };
}

export default useHeroPlannerCountryStates;
